import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import adrActions from "../../_actions/adrActions";
import AlertModal from "../_common/AlertModal";

export default function AdrTentativeAgreementCustomFormUploadV3(props) {
  const {
    customFormAttachments,
    fileUploadContext,
    addCustomFormAttachment,
    deleteCustomFormAttachment,
    isLocked,
    markTaDirty,
  } = props;

  const dispatch = useDispatch();

  const [file, setFile] = useState(null);
  const [filename, setFilename] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  useEffect(
    () =>
      setFilename(
        (customFormAttachments || []).length
          ? customFormAttachments[0].originalFilename
          : ""
      ),
    [customFormAttachments]
  );

  const [showAlert_wrongType, setShowAlert_wrongType] = useState(false);
  const toggleAlert_wrongType = () => setShowAlert_wrongType(!showAlert_wrongType);

  const handleChange_fileInput = async (e) => {
    const files = Array.from(e.target.files);
    const _file = (files || []).length ? files[0] : null;
    if (_file) {
      if (![ ".pdf", ".jpg", ".jpeg", ".png", ".docx", ".xlsx" ].includes(_file.name.substring(_file.name.lastIndexOf(".")).toLowerCase())) {
        setFile(null);
        setFilename("");
        e.target.value = null;
        toggleAlert_wrongType();
      } else {
        setFile(_file);
        setFilename(_file.name);
        setIsUploading(true);
        const formData = new FormData();

        formData.append("custom_form", _file);
        for (const key in fileUploadContext) {
          formData.append(key, fileUploadContext[key]);
        }

        try {
          const uploadedFiles = await dispatch(adrActions.uploadAttachmentV2(formData));

          if ((uploadedFiles || []).length) {
            const uploadedCustomForm = uploadedFiles[0];
            /** @type {import("../../_typedefs/adrV3TypeDefs").TentativeAgreementAttachmentDto[]} */
            const attachmentsToAdd = {
              tentativeAgreementAttachmentId: 0,
              tentativeAgreementId: 0, // Will be fixed up by backend
              originalFilename: uploadedCustomForm.originalFilename,
              filePath: uploadedCustomForm.fileRelPath,
              imageThumbnailFilePath: uploadedCustomForm.imageThumbnailFileRelPath,
              thumbnailBase64: uploadedCustomForm.thumbnailBase64,
              description: "",
              createdOn: uploadedCustomForm.createdOn,
              isCustomTa: true,
              isDeleted: false,
            };

            addCustomFormAttachment(attachmentsToAdd);
          }

          // Clear the file "holding area" once upload is complete
          setIsUploading(false);
          markTaDirty();
        } catch (err) {
          setIsUploading(false);
          setFilename("");
        }
      }
    } else {
      setFile(null);
      setFilename("");
    }
  };

  return (
    <React.Fragment>
      <div className="card mt-2 bg-lightgray">
        <div className="card-body d-flex flex-row p-2">
          <input
            type="file"
            id="upload_custom_form"
            onChange={handleChange_fileInput}
            accept=".pdf, .jpg, .jpeg, .png, .docx, .xlsx"
            hidden
          />
          <label
            htmlFor="upload_custom_form"
            className="btn btn-sm btn-primary mb-0 mr-2"
            hidden={isLocked}
          >
            <FontAwesomeIcon icon="upload" className="fa-fw mr-1" />
            Upload...
          </label>
          {customFormAttachments.length ? (
            <div className="d-flex flex-row">
              <span className="align-middle my-auto font-weight-bold mr-2">File:</span>
              <button
                id="customFormAttachmentLink"
                name="customFormAttachmentLink"
                className="btn btn-sm btn-link mr-2 flex-grow-1"
                onClick={() =>
                  dispatch(adrActions.openFile(customFormAttachments[0].filePath))
                }
                style={{ textOverflow: "ellipsis" }}
              >
                {filename}
              </button>
              <button
                id="deleteCustomFormAttachment"
                name="deleteCustomFormAttachment"
                className="btn btn-sm btn-link"
                style={{ color: "red" }}
                onClick={deleteCustomFormAttachment}
                hidden={isLocked}
                disabled={isLocked}
              >
                (Delete)
              </button>
            </div>
          ) : (
            <span className="my-auto" style={{ color: "red" }}>
              (No File Uploaded)
            </span>
          )}
        </div>
      </div>
      <AlertModal
        alertKey={"wrongType"}
        alertTitle={"Invalid File Type"}
        alertTitleClass="bg-warning"
        alertTitleIcon="exclamation-triangle"
        alertText="Only .pdf, .jpg, .jpeg, .png, .docx, and .xlsx files are supported."
        acceptCaption={"OK"}
        acceptClass={"secondary"}
        provideReject={false}
        handleAlertAction={toggleAlert_wrongType}
        showAlertModal={showAlert_wrongType}
        toggleAlertModal={toggleAlert_wrongType}
      />
    </React.Fragment>
  );
}
